import React from 'react';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from 'prop-types';
import ReduxProvider from './ReduxProvider';

const queryClient = new QueryClient();

function CombinedProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer />
      <ReduxProvider>{children}</ReduxProvider>
    </QueryClientProvider>
  );
}

CombinedProviders.propTypes = {
  children: PropTypes.node.isRequired
};

export default CombinedProviders;
